import React, {useEffect, useState} from 'react';
import {Modal} from 'semantic-ui-react'
import {ImageFormatter} from '../formatters/ImageFormatter'

const CardDetailModal = (props) => {


    const [open, setOpen] = useState(false)
    console.log(JSON.stringify(props))
    useEffect(() => {  //Set Formik state with actual name
        if (props.open) {
            setOpen(true)
        }
      }, [props.open]);

     if (props && props.card) { 
        return (
            <Modal onClose={() => setOpen(false)} onOpen={() => setOpen(true)} open={open}>
            <Modal.Header>Card Details</Modal.Header>
                <Modal.Content >
                <div className="ui grid">
                    <div className="eight wide column">
                        <div className="ui container">
                            <ImageFormatter value={props.card.imgUrl} isGallery={'true'} imgStyle={"full"} />
                        </div>
                    </div>  
                    <div className="eight wide column">
                        <div className="ui container">
                                    <div className="ui card">
                                    
                                    <div className="content">
                                        <div className="ui items">
                                            <div className="item">
                                                <div className="left aligned content">
                                                    <div className="header">{props.card.cardData.setName}</div>
                                                </div>
                                            </div>
                                            <div className="item">
                                                <div className="left aligned content">
                                                    <div className="header"> Card Number:  {props.card.cardData.cardNum}</div>
                                                </div>
                                            </div>
                                            <div className="item">
                                                <div className="left aligned content">
                                                    <div className="header">{props.card.cardData.player}</div>
                                                </div>
                                            </div>
                                        
                                            <div className="item">
                                                <div className="left aligned content">
                                                    <div className="header">{props.card.cardData.completeSetId}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* {renderPriceData(cardData.isUserLoggedIn)} */}
                                </div>

                    </div>
            </div> 
          </div>
            
                </Modal.Content>

    </Modal>
    )
        }
        else {return <div></div>}


}
export default CardDetailModal